type FocusRestore = () => void;

class FocusManager {
  private stack: FocusRestore[] = [];

  push(restore: FocusRestore) {
    this.stack.push(restore);
  }

  pop() {
    const restore = this.stack.pop();
    restore?.();
  }

  clear() {
    while (this.stack.length) {
      this.pop();
    }
  }

  saveCurrent(): FocusRestore {
    const el = document.activeElement as HTMLElement | null;
    return () => {
      if (el?.focus) {
        try {
          el.focus();
        } catch {
          /* ignore */
        }
      }
    };
  }
}

export const focusManager = new FocusManager();

export function focusElement(id: string) {
  const el = document.getElementById(id);
  el?.focus();
  return !!el;
}
